import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-3" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "alert alert-warning" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_button_ui = _resolveComponent("button-ui")!
  const _component_modal_ui = _resolveComponent("modal-ui")!

  return (_openBlock(), _createBlock(_component_modal_ui, {
    id: _ctx.id,
    size: "modal-md",
    title: "API-ключ создан"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.state.warning), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("label", { class: "form-label" }, "Секретный ключ", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              class: "form-control font-monospace",
              type: "text",
              readonly: "",
              value: _ctx.state.apiKey
            }, null, 8, _hoisted_6),
            _createElementVNode("button", {
              class: "btn btn-outline-primary",
              type: "button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyKey && _ctx.copyKey(...args)))
            }, _toDisplayString(_ctx.copied ? 'Скопировано' : 'Копировать'), 1)
          ])
        ]),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-12 mt-3" }, [
          _createElementVNode("small", { class: "text-muted" }, [
            _createTextVNode(" Используйте заголовок "),
            _createElementVNode("code", null, "X-API-Key"),
            _createTextVNode(" для "),
            _createElementVNode("code", null, "/api/v1/external/students"),
            _createTextVNode(" и "),
            _createElementVNode("code", null, "/api/v1/external/entrances"),
            _createTextVNode(". ")
          ])
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_button_ui, {
            "button-class": "btn-primary",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Готово ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["id"]))
}